module.exports = __webpack_public_path__ + "static/media/IMG_4525island low.b44993e8.JPG";